import {CodeAndExchange} from "app/instruments/types/CodeAndExchange";
import {PortfolioType} from "../../portfolio/models/Portfolio";

export interface QuoteParameters extends CodeAndExchange {
    readonly portfolioType: PortfolioType;
}

export interface TmcQuoteParameters extends QuoteParameters {
    readonly opposite: boolean;
}

export function isTmc(parameters: QuoteParameters): parameters is TmcQuoteParameters {
    return "opposite" in parameters;
}
